// Multi-tenant work packages keep their i18n keys in one file each (src/i18n/mt/<package>.ts) so that
// packages developed in parallel never edit the same line of index.ts. Merged into every language below.
import * as docprefix from './docprefix';
import * as bizcal from './bizcal';
import * as firmcontact from './firmcontact';
import * as bankscan from './bankscan';
import * as modpolicy from './modpolicy';
import * as teamcal from './teamcal';
import * as ctrlplane from './ctrlplane';
import * as dialcode from './dialcode';
import * as cpacklegal from './cpacklegal';
import * as cpackdocs from './cpackdocs';
import * as people from './people';
import * as money from './money';
import * as reqdocs from './reqdocs';
import * as zone from './zone';
import * as world from './world';
import * as invoice from './invoice';
import * as approvals from './approvals';
import * as monthlyflag from './monthlyflag';
import * as proptax from './proptax';
import * as popups from './popups';
import * as curwords from './curwords';
import * as portalintl from './portalintl';
import * as consultcal from './consultcal';
import * as acctws from './acctws';
import * as coamaster from './coamaster';   // Admin → Master chart template (COA-1)
import * as coalog from './coalog';         // the chart of accounts' change log (COA-10)
import * as coatype from './coatype';       // a client account's type, group and description (batch 5 R4)
import * as coasync from './coasync';       // the template preview on a client's chart (batch 5 R7)
import * as coarole from './coarole';       // an account's role on a client's chart (batch 8 R1)
import * as emplog from './emplog';         // the employee change log + O2's "no access" cell (batch 10 R2)
import * as exprecords from './exprecords'; // Expenses › Expense records, the register and its window (batch 7 R3a)
import * as facommon from './facommon';   // Accounting › Fixed assets — shared words (batch 9 R4)
import * as facat from './facat';         // …the Asset Categories tab
import * as fareg from './fareg';         // …the Asset Register tab, its windows, import, reconciliation
import * as fadep from './fadep';         // …the Depreciation tab
import * as faasset from './faasset';     // …the asset window, its form and action dialogs
import * as payroll from './payroll';       // the payroll module, prefix prl_ (batch 10 R3: Payroll › Employees)
import * as payrollSettings from './payrollSettings';   // Payroll › Payroll settings, prefix prs_ (batch 10 R5)
import * as payrollRuns from './payrollRuns';           // Payroll › Payroll List and the run window, prefix prr_ (batch 10 R6)
import * as payrollReports from './payrollReports';     // Payroll › Reports and its report window, prefix prp_ (batch 10 R9)
import * as paylog from './paylog';                     // a PND.1 / SSO line's History in Tax, prefix plog_ (b13 S3)
const ALL = [docprefix, bizcal, firmcontact, bankscan, modpolicy, teamcal, ctrlplane, dialcode, cpacklegal, cpackdocs, people, money, reqdocs, zone, world, invoice, approvals, monthlyflag, proptax, popups, curwords, portalintl, consultcal, acctws, coamaster, coalog, coatype, coasync, coarole, emplog, exprecords, facommon, facat, fareg, fadep, faasset, payroll, payrollSettings, payrollRuns, payrollReports, paylog];
const merge = (lang: 'en' | 'zh' | 'th'): Record<string, string> => Object.assign({}, ...ALL.map(m => m[lang]));
export const mtEn = merge('en');
export const mtZh = merge('zh');
export const mtTh = merge('th');
